<template>
  <div class="c-change-log">
    <template>
      <div
        class="c-change-log__content t-background-white-grey t-margin-bottom-s"
      >
        <h2 class="t-text-style-beta c-change-log__title">Ändringshistorik</h2>
        <template>
          <div
            class="c-change-log__listing t-margin-top-s t-margin-bottom-s"
            v-if="changeLogEntries.length > 0"
          >
            <div
              class="c-change-log-list__item t-margin-bottom-s"
              v-for="entry in changeLogEntries"
              :key="entry.date"
            >
              <span class="c-change-log__info"
                >Uppdatering - {{ formatDateAndTime(entry.date) }}</span
              >
              <div class="s-text s-text--vue" v-html="entry.message"></div>
            </div>
          </div>
          <div class="t-margin-top-s t-margin-bottom-s" v-else>
            Ändringshistorik saknas.
          </div>
        </template>
        <template v-if="showCreate">
          <form
            @submit.prevent="handleSubmit"
            class="c-form c-process-item__form"
          >
            <fieldset>
              <div class="c-form__item">
                <vue-input
                  label="Beskrivning på ändring"
                  input-id="description"
                  :maxlength="maxLength"
                  :value="description"
                  ref="description"
                  type="textarea"
                  @notifyExceedingMaxlength="notifyExceedingMaxlength"
                ></vue-input>
              </div>
              <can i="notify" a="change">
                <div class="c-form__item">
                  <vue-input
                    label="Informera om ändringarna"
                    input-id="notify"
                    type="checkbox"
                    ref="notify"
                    class="t-margin-bottom-m"
                  ></vue-input>
                </div>
              </can>
              <div class="t-margin-top-s t-margin-bottom-s">
                <button
                  type="submit"
                  :disabled="exceedingMaxlength"
                  class="c-button c-button--primary"
                  @click="setSubmitType('create')"
                >
                  Lägg till
                </button>
                <button
                  type="submit"
                  :class="`c-button c-button--linkstyle`"
                  @click="showCreateView()"
                >
                  Avbryt
                </button>
              </div>
            </fieldset>
          </form>
        </template>
        <can i="manage" :a="processType">
          <button
            v-if="!showCreate"
            class="c-button c-button--secondary"
            type="button"
            @click="showCreateView()"
          >
            Lägg till kommentar
          </button>
        </can>
        <button
          v-if="!showCreate"
          type="submit"
          :class="
            `c-button ${
              this.$can('manage', processType)
                ? 'c-button--linkstyle'
                : 'c-button--secondary'
            }`
          "
          @click="toggleChangeLog()"
        >
          Stäng
        </button>
         <button
          v-if="!showCreate && unreadNotifications"
          type="submit"
          :class="
            `c-button ${
              this.$can('manage', processType)
                ? 'c-button--linkstyle'
                : 'c-button--primary'
            }`
          "
          @click="clickedReadConsent()"
        >
        Tagit del av uppdatering
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import VueInput from "@/components/vue-components/vue-input/VueInput.vue";
export default {
  name: "ChangeLog",
  components: {
    VueInput
  },
  props: {
    processId: {
      type: String,
      default: ""
    },
    changeLogEntries: {
      type: Array,
      default: () => []
    },
     unreadNotifications: {
      type: Boolean,
      default: false
    },
    processType: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    submitType: "",
    showCreate: false,
    maxLength: 2000,
    exceedingMaxlength: false
  }),
  methods: {
    notifyExceedingMaxlength(val) {
      this.exceedingMaxlength = val;
    },
    showCreateView() {
      this.showCreate = !this.showCreate;
    },
    create() {
      let description = this.$refs.description.getValue();
      let date = new Date(new Date().toString().split("GMT")[0] + " UTC")
        .toISOString()
        .replace("Z", "");
      this.$emit("create", {
        id: this.processId,
        message: description,
        date: date,
        notify: this.$refs.notify ? this.$refs.notify.getValue() : false
      });
      this.showCreateView();
    },
    setSubmitType(type) {
      this.submitType = type;
    },
    handleSubmit() {
      switch (this.submitType) {
        case "create":
          this.create();
          break;
      }
    },
    toggleChangeLog() {
      this.$emit("toggleChangeLog");
    },
      clickedReadConsent() {
      this.$emit("logReadConsent");
    },
    formatDateAndTime(date) {
      let dateString = new Date(date).toLocaleDateString("sv-SE", {
        year: "numeric",
        month: "long",
        day: "numeric"
      });
      let timeString = new Date(date).toLocaleTimeString("sv-SE", {
        hour: "2-digit",
        minute: "2-digit"
      });
      let formattedDateAndTime = dateString + " | " + timeString;
      return formattedDateAndTime;
    }
  }
};
</script>
